import { render } from "./NavSessionPhone.vue?vue&type=template&id=0bd38117"
import script from "./NavSessionPhone.vue?vue&type=script&lang=js"
export * from "./NavSessionPhone.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__